import React from 'react';
import { CircleXIcon, SparklesIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
const pains = ['Domingos buscando ejercicios que nunca quedan bien con el nivel de tus alumnas.', 'Planificaciones armadas la noche anterior, a las corridas.', 'Siempre las mismas clases porque no tenés un banco de progresiones serio.', 'Los 5 aparatos sin sistema de integración cuerpo-aparato.', 'Grupos con distintos niveles sin material diferenciado: enseñás al promedio y perdés a todas.', 'Fin de semana agotado. El lunes volvió a empezar el mismo ciclo.'];
const transformations = ['Sin buscar ejercicios en internet', 'Progresiones paso a paso', 'Correcciones por elemento', 'Clases listas en 10 minutos'];
export function PainAndTransformation() {
  return <>
      <section className="border-y border-line bg-surface px-4 py-12 md:py-16" data-id="element-217" data-mp="b0ubdb2b0975">
        <div className="mx-auto max-w-4xl" data-id="element-218" data-mp="62iyergppikp">
          <Eyebrow danger data-id="element-219" data-mp="10w2uwgmu6i0l">😤 La realidad</Eyebrow>
          <SectionTitle data-id="element-220" data-mp="10wb5u2zefd95">
            ¿Cuántos domingos más <span className="text-gold" data-id="element-221" data-mp="14x4tcv8xiq1i">vas a perder así?</span>
          </SectionTitle>
          <p className="mx-auto mt-6 max-w-3xl text-center font-medium text-zinc-300" data-id="element-222" data-mp="qxlxp1xb1763">
            Amás la rítmica. Pero nadie te dijo que ibas a pasar los domingos buscando ejercicios que
            no encajan, armando clases a la noche y llegando al lunes con material que “más o menos
            sirve”.
          </p>
          <ul className="mt-9 grid gap-3 sm:grid-cols-2 md:gap-4" data-id="element-223" data-mp="lz27uqflbb8g">
            {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-line bg-ink p-4" data-id="element-224" data-mp="87x87oc82iy4">
                <CircleXIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-red-400" data-id="element-225" data-mp="d3unrsfnvl9u" />
                <span className="text-sm font-medium text-zinc-200 md:text-base" data-id="element-226" data-mp="3ugooe1q148oj">{pain}</span>
              </li>)}
          </ul>
          <p className="mt-10 rounded-2xl border border-gold/30 bg-gold/[0.06] p-6 text-center text-lg font-bold text-zinc-100 md:text-2xl" data-id="element-227" data-mp="3g926ye0dtokl">
            No es falta de vocación.
            <br data-id="element-228" data-mp="36ir30rgp7fdp" />
            <span className="text-xl text-gold md:text-3xl" data-id="element-229" data-mp="36i7jj6begixk">Es falta de un sistema.</span>
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-12 md:py-16" data-id="element-230" data-mp="31lh48l7f5rd7">
        <Eyebrow data-id="element-231" data-mp="32jzckya9i4x">
          <span className="inline-flex items-center gap-2" data-id="element-232" data-mp="30z4eu823x6j">
            <SparklesIcon aria-hidden="true" className="h-4 w-4" data-id="element-233" data-mp="3u8utry8sfkna" /> La transformación
          </span>
        </Eyebrow>
        <SectionTitle data-id="element-234" data-mp="3p8pab5co94ga">
          ¿Y si este fuera <span className="text-gold" data-id="element-235" data-mp="3p7nms1egypho">el último domingo que pasó así?</span>
        </SectionTitle>
        <div className="mt-8 rounded-3xl border border-gold/25 bg-surface p-6 md:p-10" data-id="element-236" data-mp="3ka5mezeipila">
          <p className="text-center text-base font-bold leading-relaxed text-white md:text-xl" data-id="element-237" data-mp="2dvwkw17css3e">
            Abrís el tomo del aparato. Elegís el nivel. Tomás la clase del mes. En 10 minutos está
            cerrada y el domingo vuelve a ser tuyo.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-238" data-mp="tbrgsual79xm">
            {transformations.map(item => <p key={item} className="rounded-xl border border-gold/25 bg-ink p-3 text-center text-xs font-bold text-gold md:text-sm" data-id="element-239" data-mp="yacfuqe3rnkh">
                {item}
              </p>)}
          </div>
          <p className="mt-6 text-center font-medium text-zinc-300" data-id="element-240" data-mp="183jm0dgo37lm">
            Eso es <strong className="text-white" data-id="element-241" data-mp="1c0z6dv9pm75h">Gimnasia Rítmica PRO.</strong>
          </p>
        </div>
        <div className="mt-8 text-center" data-id="element-242" data-mp="1h2oeb21my4pc">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:text-base" data-id="element-243" data-mp="1m1hwv8vs4lwd">
            Quiero mi Gimnasia Rítmica PRO ahora →
          </Button>
        </div>
      </section>
    </>;
}